import { render, staticRenderFns } from "./ResponsibilitiesList.vue?vue&type=template&id=4b0b7712&scoped=true&"
import script from "./ResponsibilitiesList.vue?vue&type=script&lang=js&"
export * from "./ResponsibilitiesList.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibilitiesList.vue?vue&type=style&index=0&id=4b0b7712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b7712",
  null
  
)

export default component.exports